define(["./map"], function(map) {
  return map;
});
